module.exports = __webpack_public_path__ + "img/Skip bins.5d047ae1.svg";